/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import type { JiraHomePageNestedEntryPoints } from '@jira/global-pages__home-recommendations-recommended-tab/src/jiraHomeRecommendedTabNestedEntryPoints.types.tsx';
import { recommendedTabEntryPoint } from '@jira/global-pages__home-recommendations-recommended-tab/src/recommendedTab.entrypoint.tsx';
import { expValEquals } from '@atlassian/jira-feature-experiments';
import { fg } from '@atlassian/jira-feature-gating';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters, { type JiraHomePageQuery } from './__generated__/JiraHomePageQuery.graphql.ts';

type JiraHomePageEntryPointQueries = {
	homePageQuery?: JiraHomePageQuery;
};

type JiraHomePageEntryPointComponent = EntryPointComponent<
	JiraHomePageEntryPointQueries,
	JiraHomePageNestedEntryPoints,
	{},
	{} | null
>;

export const jiraHomePageEntryPoint: EntryPoint<
	JiraHomePageEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<JiraHomePageEntryPointComponent>(
		/* webpackChunkName: "async-jira-home-page-entrypoint" */ './JiraHomePage.tsx',
	),
	getPreloadProps: (entryPointRouteParams: EntryPointRouteParams) => {
		const { cloudId } = entryPointRouteParams.tenantContext;
		const isRecommendedTabPreloadedEnabled =
			expValEquals('recommended_actions_on_for_you', 'isEnabled', true, false) &&
			expValEquals('for_you_recommended_tab_preloaded_query', 'isEnabled', true, false);

		return {
			queries: {
				...(fg('jfy-integrate-new-user-check') && {
					homePageQuery: {
						options: {
							fetchPolicy: 'network-only' as const,
						},
						parameters,
						variables: {
							cloudId,
						},
					},
				}),
			},
			entryPoints: {
				// When disabled, omit the key so static route generation does not iterate `undefined`.
				...(isRecommendedTabPreloadedEnabled && {
					recommendedTab: {
						entryPoint: recommendedTabEntryPoint,
						entryPointParams: entryPointRouteParams,
					},
				}),
			},
			extraProps: {},
		};
	},
});
